export default "__VITE_ASSET__D$sQzZcz__"